import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import 'rxjs/add/operator/map';

//import decode from 'jwt-decode';


//let apiUrl = 'http://plentyclip.apps/api/auth/';
// let apiUrl = 'http://plentyclip.apps/api/'; 
 let apiUrl = 'https://api.picmasters.de/api/admins/';

@Injectable()
export class AuthServiceProvider {

  constructor(public http : Http) {
    console.log('Hello AuthService Provider');
  }

  public getToken(): string {
    return localStorage.getItem('token');
  }

  // public isAuthenticated(): boolean {
  //   // get the token
  //   const token = this.getToken();
  //   // return a boolean reflecting 
  //   // whether or not the token is expired
  //   return tokenNotExpired(token);
  // }

  postData(credentials, type) {
    return new Promise((resolve, reject) => {
      let headers = new Headers();
      //headers.append('Accept', 'application/json');
      headers.append('Content-Type', 'application/x-www-form-urlencoded');

      
      //headers.append('X-Requested-With', 'XMLHttpRequest');
      this.http.post(apiUrl + type, JSON.stringify(credentials), {headers: headers})
      //this.http.post(apiUrl + type, JSON.stringify(credentials), {headers: headers})
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          reject(err);
        });
    });

  }




}



// WEBPACK FOOTER //
// ./src/providers/auth-service/auth-service.ts